import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ConfigProvider } from 'antd'
// 修复点1：6.1.1版本必须加/es/路径，且命名是zh_CN（下划线）
import zhCN from 'antd/es/locale/zh_CN'
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 修复点2：
        1. locale={zhCN} 作为属性写在ConfigProvider标签内
        2. App组件必须包裹在ConfigProvider内部，才能让语言配置生效
    */}
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// 性能监控（保留原有代码即可）
reportWebVitals();